<template lang="pug">
  LeadsList(:leads="leads" create=false title="Due Leads")
</template>

<script>
import dashboardService from '../../service.js'
import LeadsList from '../../../Leads/components/LeadsList'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      leads: []
    }
  },
  components: {
    LeadsList,
  },
  computed: {
    ...mapGetters('global', ['currentUser'])
  },
  mounted() {
    this.getListOfUserDueLeads(this.currentUser.userID)
  },
  watch: {
    currentUser(val) {
      this.getListOfUserDueLeads(val.userID)
    },
  },
  methods: {
    getListOfUserDueLeads(id) {
      return dashboardService
      .getListOfUserDueLeads(id)
      .then((response) => {
        this.leads = response.data
      })
    },
  }
}
</script>

<style scoped>
</style>